import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=78361343&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=ts"
export * from "./CustomModal.vue?vue&type=script&lang=ts"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=78361343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78361343",
  null
  
)

export default component.exports